<template>
    <div class="toast-container">
        <TransitionGroup name="toast-list" tag="div" class="toast-stack">
            <ConfirmationToast
                v-for="toast in notificationStore.toasts"
                :key="toast.id"
                :title="toast.message"
                :description="toast.description"
                :icon="getIcon(toast.type)"
                :timeToClose="toast.duration || 5000"
                @close="handleClose(toast.id)"
            />
        </TransitionGroup>
    </div>
</template>

<script setup>
import { useNotificationStore } from '@/store/pinia/notifications';
import ConfirmationToast from './ConfirmationToast.vue';

const notificationStore = useNotificationStore();

const iconMap = {
    success: 'popup_check_circle',
    error: 'fail_cross_circle',
    warning: 'obsolete_lightning_bolt',
    info: 'notification_bell',
    confirm: 'confirmation_toast_icon'
};

const getIcon = (type) => iconMap[type] || 'confirmation_toast_icon';

const handleClose = (toastId) => {
    notificationStore.removeToast(toastId);
};
</script>

<style scoped>
.toast-container {
    position: fixed;
    top: 24px;
    right: 24px;
    z-index: 9999;
    pointer-events: none;
}

.toast-stack {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-end;
}

.toast-stack > * {
    pointer-events: auto;
}

.toast-list-enter-active,
.toast-list-leave-active {
    transition: all 0.3s ease;
}

.toast-list-enter-from {
    opacity: 0;
    transform: translateX(100px);
}

.toast-list-leave-to {
    opacity: 0;
    transform: translateX(100px) scale(0.8);
}

.toast-list-move {
    transition: transform 0.3s ease;
}
</style>
